import tagModel from "../../../../models/custom-vision/custom-vision.tags.model";
import ViewBase from '../../../view-base.view';
import CommonFooterComponent from "../common-footer.component";

export default function CVTagEditView() {
  ViewBase.call(this);

  let _hasData = false;
  let inputDataModel = { tagName: "", tagDescription: "" };
  let selectedProjectId = 0;
  let selectedTagId = 0;
  let listOfTags = [];

  let _onPopupClose = (e) => { };
  let _onSaveComplete = (e) => { }
  let _cancel = (e) => {
    _onPopupClose(e);
  }

  let _save = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    tagModel.editTag(
      (result) => {
        _onSaveComplete(result);
      },
      (error) => {
        this.handleError(error);
      },
      listOfTags,
      selectedProjectId,
      selectedTagId,
      inputDataModel.tagName,
      inputDataModel.tagDescription
    );
  }

  let _getTagName = (e) => {
    inputDataModel.tagName = e.target.value;
  }

  let _getTagDescription = (e) => {
    inputDataModel.tagDescription = e.target.value;
  }

  let _loadTag = () => {
    tagModel.getTag(
      (result) => {
        selectedTagId = result.id;
        inputDataModel.tagName = result.name;
        inputDataModel.tagDescription = result.description;

      }, (error) => {
        this.handleError(error);
      },
      selectedProjectId,
      selectedTagId);
  }

  let _checkData = () => {
    if (selectedTagId > 0) {
      _hasData = true;
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onPopupClose) {
        _onPopupClose = vnode.attrs.onPopupClose;
      }

      if (vnode.attrs.onSaveComplete) {
        _onSaveComplete = vnode.attrs.onSaveComplete;
      }

      if (vnode.attrs.projectId && vnode.attrs.tagId) {
        selectedProjectId = vnode.attrs.projectId;
        selectedTagId = vnode.attrs.tagId;

        _loadTag();
      }

      if (vnode.attrs.listOfTags) {
        listOfTags = vnode.attrs.listOfTags;
      }
    },
    view: () => {
      _checkData();

      return [
        !_hasData &&
        m('span', this.getText("LT00000291", "No records found.")),

        _hasData &&
        m('.row',
          m('col-md-12',
            m('.card',
              m('.card-body',
                m('form#mainFormTag[novalidate].needs-validation',
                  m('.row.col-md-12',
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000134", "Tag"), m('span.redText', "*")),
                      m('input[type=text][required][maxlength=50][placeholder=' + this.getText("LT00000134", "Tag") + '][value="' + inputDataModel.tagName + '"].form-control.form-control-bg.text-uppercase', { onchange: _getTagName }),
                      m('.invalid-feedback', this.getText("LT00000376", "Please enter a name for the tag."))
                    ),
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000012", "Description")),
                      m('textarea#txtContent.form-control.form-control-bg', {
                        placeholder: this.getText("LT00000012", "Description"),
                        onchange: _getTagDescription,
                        style: "height: 185px;",
                        maxlength: 255
                      },
                        inputDataModel.tagDescription
                      )
                    )
                  )
                )
              ),
              m(CommonFooterComponent, {
                actionHandler: _save,
                cancelHandler: _cancel,
              }),
            )
          ),
        ),
        this.getBaseViews()
      ];
    },
  };
}
